import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { WEB_LOGIN_PATH } from "../../../routes/authPaths";

const EmailVerificationPending = () => {
  const [isSending, setIsSending] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const userId = params.get("userId");

  useEffect(() => {
    if (!email || !userId) {
      navigate(WEB_LOGIN_PATH);
    }
  }, [email, userId, navigate]);

  if (!email || !userId) {
    return null;
  }

  const handleResendEmail = async () => {
    if (isSending) return;

    setIsSending(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/send-verification-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          userId
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to resend verification email");
      }

      toast.success("Verification email sent! Please check your inbox.");
    } catch (error) {
      console.error("Error resending verification email:", error);
      toast.error("Failed to resend verification email.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="email-verification-pending">
      <div className="email-verification-pending__container">
        <h1 className="email-verification-pending__title">Please verify your email.</h1>

        <p className="email-verification-pending__text" style={{ marginLeft: '20px', marginRight: '20px' }}>
          Click the link in your email <strong>{email}</strong> to verify!<br />
          If you don't see it in a few minutes, check your junk mail, or we can <button
            onClick={handleResendEmail}
            disabled={isSending}
            className="email-verification-pending__resend-button"
          >{isSending ? "sending..." : "resend the email"}</button>.
        </p>
      </div>
    </div>
  );
};

export default EmailVerificationPending; 